import React from 'react'
import { SecurityAndPermissionsDataTable } from './SecurityAndPermissionsDataTable'
import { useThemeMode } from '../../../../../_metronic/partials';

const SecurityAndPermissions = ({metaData}:{metaData:any}) => {
    const { mode } = useThemeMode();
    return (
        <div>
            <div className='rounded' style={mode === 'dark' ? { background: '#151521' } : {}}>
                <SecurityAndPermissionsDataTable metaData={metaData}/>
            </div>
        </div>
    )
}

export default SecurityAndPermissions
